import { Role, UserWhereInput } from '../../../__generated__/graphql';

import { ActiveMembership } from '../../../redux/reducers/@types/MeReduxState';
import { DataTableFilterValues } from '../../../@types/client/DataTableFilterValues';

export default function parseUserQueryParameters(
  fieldsFiltered: DataTableFilterValues[],
  membership: ActiveMembership
): Partial<UserWhereInput> {
  const whereInput: Partial<UserWhereInput> = {};

  if (fieldsFiltered && fieldsFiltered.length > 0) {
    // Role filter
    const roleFieldsIndex = fieldsFiltered.findIndex((field) => field.fieldKey === 'role');
    if (roleFieldsIndex > -1) {
      const inInput = fieldsFiltered[roleFieldsIndex].values as Role[];

      whereInput.memberships = {
        some: {
          ...(membership.location && { locationId: { equals: membership.location.id } }),
          role: {
            in: inInput,
          },
          tenantId: { equals: membership.tenant.id },
        },
      };
    }
  }

  return whereInput;
}
